// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bv1b66{padding-left:var(--ds-space-050,4px)}\n._1bah1e5h{justify-content:left}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
